import React, { useState, useEffect, useRef } from "react";
import "./doctorSpecialization.css";
import Widgets from "../../widgets";
import plusIcon from "../../Assets/Icons/PlusIcon.png";
import DepartmentList from "./departmentList";
import { useTranslation } from "react-i18next";

const DoctorSpecialization = ({ setSelectedView, onDepartmentSelect }) => {
  const breadcrumbs = ["video_Consultation", "departments"];
  const paths = ["/department", "/department"];
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(1);
  const { t } = useTranslation();
  const topRef = useRef(null);
  const [search, setSearch] = useState(null);

  useEffect(() => {}, []);

  const handleSearch = (query) => {
    setSearch(query);
  };

  const handleButtonClick = () => {
    setSelectedView("addSpeciality");
  };

  const handleItemClick = (department) => {
    onDepartmentSelect(department);
  };

  const scrollToTop = () => {
    setTimeout(() => {
      if (topRef.current) {
        topRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 1);
  };

  return (
    <div className="department-box">
      <div ref={topRef}></div>
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="department-heading">{t("departments")}</div>
      <div className="department-results">
        {totalEntries} {t("entriesFound")}
      </div>
      <div className="department-search-line">
        <Widgets.SearchBox onSearch={handleSearch} placeholder={"searchByDeptName"} />
        <Widgets.IconButton iconSrc={plusIcon} buttonText="newDept" onClick={handleButtonClick} />
      </div>
      <DepartmentList onItemClick={handleItemClick} currentPage={currentPage} setCurrentPage={setCurrentPage} scrollToTop={scrollToTop} setTotalEntries={setTotalEntries} handleSearch={search} />
    </div>
  );
};

export default DoctorSpecialization;
